import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: 'Welcome' },
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About/About.vue')
  },
  {
    path: '/colors',
    name: 'Colors',
    meta: { title: 'Colors' },
    component: () => import(/* webpackChunkName: "colors" */ '../views/Colors/Colors.vue')
  },
  {
    path: '/icons',
    name: 'Icons',
    meta: { title: 'Icons' },
    component: () => import(/* webpackChunkName: "icons" */ '../views/Icons/Icons.vue')
  },
  {
    path: '/logotypes',
    name: 'Logotypes',
    meta: { title: 'Logotypes' },
    component: () => import(/* webpackChunkName: "logotypes" */ '../views/Logotypes/Logotypes.vue')
  },
  {
    path: '/typography',
    name: 'Typography',
    meta: { title: 'Typography' },
    component: () => import(/* webpackChunkName: "typography" */ '../views/Typography/Typography.vue')
  },
  {
    path: '/spacing',
    name: 'Spacing',
    meta: { title: 'Spacing' },
    component: () => import(/* webpackChunkName: "spacing" */ '../views/Spacing/Spacing.vue')
  },
  {
    path: '/core',
    meta: { title: 'Core' },
    component: () => import(/* webpackChunkName: "core" */ '../views/Core/Core.vue'),
    children: [
      {
        path: '',
        name: 'Core',
        meta: { title: 'Core' },
        component: () => import(/* webpackChunkName: "core" */ '../views/Core/subviews/About.vue')
      },
      {
        path: '/core/functions',
        name: 'CoreFunctions',
        meta: { title: 'Core' },
        component: () => import(/* webpackChunkName: "core" */ '../views/Core/subviews/Functions.vue')
      },
      {
        path: '/core/utils',
        name: 'coreUtils',
        meta: { title: 'Core' },
        component: () => import(/* webpackChunkName: "core" */ '../views/Core/subviews/Utils.vue')
      },
      {
        path: '/core/variables',
        name: 'coreVariables',
        meta: { title: 'Core' },
        component: () => import(/* webpackChunkName: "core" */ '../views/Core/subviews/Variables.vue')
      }
    ]
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackChunkName: "test" */ '../views/TestComponents.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
